import axios from 'axios';

import { authHeader } from '@H';

export default {
  getDSRChart: (time) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/product-sale-summary/?dsr_date=${time}`,
    }),
  getDSRDates: (month, year) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/dsr/dsr-date/?month=${month}&year=${year}`,
    }),
};
